



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { TsManagerUser } from '@/interfaces'

@Component({
  name: 'PerformanceManagerCard'
})
export default class PerformanceManagerCard extends Vue {
  @Prop({ required: true })
  manager!: TsManagerUser
}
